var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuideIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "guideIcon2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1251",
    "data-name": "\\uD0C0\\uC6D0 1251",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59364",
    "data-name": "\\uADF8\\uB8F9 59364",
    transform: "translate(11 12.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20-manual",
    "data-name": "20-manual"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34181",
    "data-name": "\\uD328\\uC2A4 34181",
    d: "M45.421,8.732V26.915a1.732,1.732,0,0,1-1.732,1.732H32V26.915h9.958V24.331q.643-.013,1.3-.013V7h.433A1.732,1.732,0,0,1,45.421,8.732Z",
    transform: "translate(-18.579 -5.268)",
    fill: "#4f575b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34182",
    "data-name": "\\uD328\\uC2A4 34182",
    d: "M41.958,22.063c-3.81.091-7.235.641-9.958,2.585V5.6C35.031,3.433,38.927,3,43.257,3V22.05Q42.6,22.05,41.958,22.063Z",
    transform: "translate(-18.579 -3)",
    fill: "#e7f1fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34183",
    "data-name": "\\uD328\\uC2A4 34183",
    d: "M41.958,47.03v2.585H32C34.723,47.671,38.148,47.121,41.958,47.03Z",
    transform: "translate(-18.579 -27.967)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34184",
    "data-name": "\\uD328\\uC2A4 34184",
    d: "M14.421,26.915v1.732H2.732A1.732,1.732,0,0,1,1,26.915V8.732A1.732,1.732,0,0,1,2.732,7h.433V24.318q.656,0,1.3.013v2.585Z",
    transform: "translate(-1 -5.268)",
    fill: "#71787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34185",
    "data-name": "\\uD328\\uC2A4 34185",
    d: "M7.3,22.063Q6.656,22.05,6,22.05V3c4.329,0,8.226.433,11.257,2.6v19.05C14.533,22.7,11.109,22.153,7.3,22.063Z",
    transform: "translate(-3.835 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34186",
    "data-name": "\\uD328\\uC2A4 34186",
    d: "M18.958,49.615H9V47.03C12.81,47.121,16.235,47.671,18.958,49.615Z",
    transform: "translate(-5.536 -27.967)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34188",
    "data-name": "\\uD328\\uC2A4 34188",
    d: "M17.732,39.13a19.081,19.081,0,0,0-6.776-1.264L10.994,37a19.881,19.881,0,0,1,7.079,1.333Z",
    transform: "translate(-6.646 -22.28)",
    fill: "#e1e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34189",
    "data-name": "\\uD328\\uC2A4 34189",
    d: "M17.732,34.13a19.081,19.081,0,0,0-6.776-1.264L10.994,32a19.881,19.881,0,0,1,7.079,1.333Z",
    transform: "translate(-6.646 -19.445)",
    fill: "#e1e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34190",
    "data-name": "\\uD328\\uC2A4 34190",
    d: "M17.732,29.13a19.081,19.081,0,0,0-6.776-1.264L10.994,27a19.881,19.881,0,0,1,7.079,1.333Z",
    transform: "translate(-6.646 -16.609)",
    fill: "#e1e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34191",
    "data-name": "\\uD328\\uC2A4 34191",
    d: "M17.732,24.13a19.081,19.081,0,0,0-6.776-1.264L10.994,22a19.881,19.881,0,0,1,7.079,1.333Z",
    transform: "translate(-6.646 -13.774)",
    fill: "#e1e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34192",
    "data-name": "\\uD328\\uC2A4 34192",
    d: "M17.732,19.13a19.081,19.081,0,0,0-6.776-1.264L10.994,17a19.881,19.881,0,0,1,7.079,1.333Z",
    transform: "translate(-6.646 -10.939)",
    fill: "#e1e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34193",
    "data-name": "\\uD328\\uC2A4 34193",
    d: "M17.732,14.13a19.081,19.081,0,0,0-6.776-1.264L10.994,12a19.881,19.881,0,0,1,7.079,1.333Z",
    transform: "translate(-6.646 -8.103)",
    fill: "#e1e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34194",
    "data-name": "\\uD328\\uC2A4 34194",
    d: "M36.947,34.13l-.341-.8A19.879,19.879,0,0,1,43.685,32l.038.866A19.073,19.073,0,0,0,36.947,34.13Z",
    transform: "translate(-21.191 -19.445)",
    fill: "#afb4c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34195",
    "data-name": "\\uD328\\uC2A4 34195",
    d: "M36.947,29.13l-.341-.8A19.879,19.879,0,0,1,43.685,27l.038.866A19.073,19.073,0,0,0,36.947,29.13Z",
    transform: "translate(-21.191 -16.61)",
    fill: "#afb4c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34196",
    "data-name": "\\uD328\\uC2A4 34196",
    d: "M36.947,24.13l-.341-.8A19.879,19.879,0,0,1,43.685,22l.038.866A19.073,19.073,0,0,0,36.947,24.13Z",
    transform: "translate(-21.191 -13.775)",
    fill: "#afb4c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34197",
    "data-name": "\\uD328\\uC2A4 34197",
    d: "M36.947,19.13l-.341-.8A19.879,19.879,0,0,1,43.685,17l.038.866A19.073,19.073,0,0,0,36.947,19.13Z",
    transform: "translate(-21.191 -10.939)",
    fill: "#afb4c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34198",
    "data-name": "\\uD328\\uC2A4 34198",
    d: "M36.947,14.13l-.341-.8A19.879,19.879,0,0,1,43.685,12l.038.866A19.073,19.073,0,0,0,36.947,14.13Z",
    transform: "translate(-21.191 -8.104)",
    fill: "#afb4c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lamp",
    transform: "translate(19.925 11.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34199",
    "data-name": "\\uD328\\uC2A4 34199",
    d: "M20.615,8.608a10.377,10.377,0,0,0-1.15,2.517.236.236,0,0,1-.232.182L14.941,11.3a.239.239,0,0,1-.232-.182c-.022-.086-.05-.184-.089-.3A8.271,8.271,0,0,0,13.567,8.81,5.047,5.047,0,0,1,12.36,5.428a4.967,4.967,0,0,1,1.9-3.458A4.76,4.76,0,0,1,17.111,1a4.5,4.5,0,0,1,2.517.848,4.554,4.554,0,0,1,.491.376l.007.01A4.766,4.766,0,0,1,21.7,4.851a4.776,4.776,0,0,1-1.085,3.758Z",
    transform: "translate(-12.353 -1)",
    fill: "#ffab37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34200",
    "data-name": "\\uD328\\uC2A4 34200",
    d: "M20.136,8.129a10.377,10.377,0,0,0-1.15,2.517.236.236,0,0,1-.232.182l-4.134-.007A8.271,8.271,0,0,0,13.567,8.81,5.047,5.047,0,0,1,12.36,5.428a4.967,4.967,0,0,1,1.9-3.458A4.76,4.76,0,0,1,17.111,1a4.5,4.5,0,0,1,2.517.848,4.554,4.554,0,0,1,.491.376l.007.01a4.493,4.493,0,0,1,1.094,2.139,4.776,4.776,0,0,1-1.085,3.758Z",
    transform: "translate(-12.353 -1)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34201",
    "data-name": "\\uD328\\uC2A4 34201",
    d: "M25.617,28.888a.239.239,0,0,1-.239-.239V25.725H24.261v2.919a.239.239,0,1,1-.479,0V25.725h-.429a.827.827,0,0,1,0-1.655h.081a.827.827,0,0,1,.826.826v.35h1.116V24.9a.828.828,0,0,1,.829-.826H26.3a.827.827,0,1,1,0,1.654h-.443v2.925a.239.239,0,0,1-.239.239Zm.239-3.643H26.3a.35.35,0,0,0,.35-.35.342.342,0,0,0-.1-.243.356.356,0,0,0-.249-.1h-.093a.349.349,0,0,0-.35.347Zm-2.5-.7a.348.348,0,1,0,0,.7h.429V24.9a.347.347,0,0,0-.347-.347Z",
    transform: "translate(-20.09 -18.545)",
    fill: "#ffab37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34202",
    "data-name": "\\uD328\\uC2A4 34202",
    d: "M25.177,45.144a1.2,1.2,0,0,1-.872.479l-.469,0-2.9-.007a1.21,1.21,0,0,1-.891-.484,4.4,4.4,0,0,1-.359-2.78.239.239,0,0,1,.223-.2h.034l5.379.014a.237.237,0,0,1,.235.2A4.4,4.4,0,0,1,25.177,45.144Z",
    transform: "translate(-17.866 -32.295)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34203",
    "data-name": "\\uD328\\uC2A4 34203",
    d: "M24.7,45.144a1.192,1.192,0,0,1-.862.477l-2.9-.007a1.21,1.21,0,0,1-.891-.484,4.4,4.4,0,0,1-.359-2.78.239.239,0,0,1,.223-.2l4.933.014a.237.237,0,0,1,.235.2A4.4,4.4,0,0,1,24.7,45.144Z",
    transform: "translate(-17.866 -32.295)",
    fill: "#b0bec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34204",
    "data-name": "\\uD328\\uC2A4 34204",
    d: "M28.467,55.327a1.656,1.656,0,0,1-1.655,1.65h0a1.647,1.647,0,0,1-1.379-.752,1.617,1.617,0,0,1-.268-.908.232.232,0,0,1,.069-.168.237.237,0,0,1,.17-.069l2.57.007h.259a.239.239,0,0,1,.239.239Z",
    transform: "translate(-22.093 -42.129)",
    fill: "#78909c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34205",
    "data-name": "\\uD328\\uC2A4 34205",
    d: "M27.969,55.087A1.654,1.654,0,0,1,26.333,56.5h0a1.617,1.617,0,0,1-.9-.273,1.617,1.617,0,0,1-.268-.908.232.232,0,0,1,.069-.168.237.237,0,0,1,.17-.069Z",
    transform: "translate(-22.093 -42.129)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34206",
    "data-name": "\\uD328\\uC2A4 34206",
    d: "M25.681,48.663a1.85,1.85,0,0,1-.8,1.561h0a1.219,1.219,0,0,1-.493.151l-3.374-.01c-.5-.048-1.092-.347-1.272-1.487q-.018-.1-.029-.216a.237.237,0,0,1,.06-.184.239.239,0,0,1,.177-.079h5.491a.239.239,0,0,1,.237.263Z",
    transform: "translate(-17.951 -37.048)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34207",
    "data-name": "\\uD328\\uC2A4 34207",
    d: "M25.3,50.663a2.644,2.644,0,0,1-.316,1.082h0a1.219,1.219,0,0,1-.493.151l-3.374-.01c-.5-.048-1.092-.347-1.272-1.487h5.221a.239.239,0,0,1,.177.079A.237.237,0,0,1,25.3,50.663Z",
    transform: "translate(-18.047 -38.569)",
    fill: "#b0bec5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIcon2);
export default __webpack_public_path__ + "static/media/guideIcon2.e3d983d73aedacfb22a067b174672525.svg";
export { ForwardRef as ReactComponent };